<template>
    <svg viewBox="0 0 20 28" width="20" height="28">
        <path :fill="color" d="M9.37,0c0.42,0,0.83,0,1.25,0c0.4,0.06,0.8,0.12,1.2,0.19c4.02,0.7,7.3,4,7.99,8.02C19.88,8.64,19.94,9.07,20,9.5 c0,0.33,0,0.67,0,1c-0.03,0.23-0.07,0.47-0.1,0.7c-0.19,1.58-0.77,3.01-1.61,4.35c-2.48,3.96-4.95,7.93-7.44,11.89 c-0.42,0.67-1.29,0.67-1.71,0.01c-2.54-4.06-5.07-8.12-7.6-12.19C0.21,13.1-0.29,10.75,0.2,8.26c0.82-4.13,3.32-6.77,7.37-7.93 C8.15,0.16,8.77,0.11,9.37,0z M10.01,5.43c-2.53,0-4.58,2.04-4.58,4.56c0,2.52,2.06,4.58,4.58,4.57c2.5,0,4.55-2.05,4.56-4.56 C14.58,7.47,12.54,5.43,10.01,5.43z"/>
    </svg>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            default: '#000000'
        }
    }
}
</script>